import React from 'react';
import IconBase from 'react-icon-base';

class InterestsIcon extends React.Component {
    shouldComponentUpdate() {
        return false;
    }

    render() {
        return (
            <IconBase viewBox="-6.5 -6.5 53 53" {...this.props}>
                <path
                    // eslint-disable-next-line
                    d="M28.1,25.7c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4 C27,23.3,28.1,24.3,28.1,25.7z M30,25.7c0-2.4-1.9-4.3-4.3-4.3c-2.4,0-4.3,1.9-4.3,4.3c0,2.4,1.9,4.3,4.3,4.3 C28.1,30,30,28.1,30,25.7z M16.7,14.3c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4 C15.7,11.9,16.7,13,16.7,14.3z M18.7,14.3c0-2.4-1.9-4.3-4.3-4.3c-2.4,0-4.3,1.9-4.3,4.3c0,2.4,1.9,4.3,4.3,4.3 C16.7,18.7,18.7,16.7,18.7,14.3z M12.3,29.5l-1.4-1.4l17.2-17.2l1.4,1.4L12.3,29.5z"
                />
            </IconBase>
        );
    }
}

export default InterestsIcon;



/** WEBPACK FOOTER **
 ** /src/shared/components/icons/Interests.js
 **/